// utils
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

// types
import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { GUEST_LIST },
} = NAV_DATA;
const ONBOARD_PATH = '/wedding/onboard/wedding-guest-list';

const getGuestList = (): MegaMenuNavItem => {
  return {
    title: 'Guest List',
    id: GUEST_LIST,
    path: '/wedding-planning/guests',
    parent: 'GuestList',
    callToAction: {
      path: ONBOARD_PATH,
      title: 'Get Started',
      items: [
        "Collects guests' mailing addresses for you",
        'Tracks RSVPs for multiple wedding events',
        "Syncs with Zola's invites and website tools",
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Guest List',
        path: '/wedding/manage/guests/all',
      },
      {
        title: 'Your Super Link',
        path: '/wedding/manage/guests/collection-link',
      },
      {
        title: 'Your Events',
        path: '/wedding/manage/events',
      },
      {
        title: 'Track Your RSVPs',
        path: '/wedding/manage/guests/rsvps/overview',
      },
      {
        title: 'Your Seating Chart',
        path: '/wedding/manage/seating',
      },
    ],
    children: [
      {
        headline: 'Build Your Guest List',
        children: [
          {
            title: 'Add Guests',
            path: ONBOARD_PATH,
          },
          {
            title: "Get Guests' Addresses",
            path: ONBOARD_PATH,
            newTag: true,
          },
          {
            title: 'Create an Event',
            path: ONBOARD_PATH,
          },
          {
            title: 'Create a Seating Chart',
            path: ONBOARD_PATH,
          },
        ],
      },
      {
        headline: 'Explore Zola Guest List',
        borderLeft: true,
        children: [
          {
            title: "RSVP to a Couple's Wedding",
            path: '/search/wedding-registry',
          },
          {
            title: 'About Zola Guest List',
            path: '/wedding-planning/guests',
          },
          {
            title: 'Book Hotel Blocks',
            path: 'https://zola.hotelplanner.com/Group-Rate/?kw=guestnav',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          {
            title: 'Guest List Expert Advice',
            path: '/expert-advice/topic/planning-101/getting-started',
          },
          {
            title: 'Guest List FAQs',
            path: 'https://help.zola.com/hc/en-us/categories/115000345711-Guest-List',
          },
        ],
      },
    ],
  };
};

export default getGuestList;
